import getActorsBySellerIdQuery from './getActorsBySellerIdQuery';
import getActorSummary from './getActorSummary';
import getSalesChannelsBySellerId from './getSalesChannelsBySellerId';
import { getSalesChannelsQuery } from './getSalesChannelsQuery';
import getStoreByExternalIdQuery from './getStoreByExternalIdQuery';
import getStoresBySellerId from './getStoresBySellerId';
import getStoresQuery from './getStoresQuery';
import deleteSelfOnboardingActorCommand from './selfonboarding/deleteSelfOnboardingActorCommand';
import getSelfOnboardingActorQuery from './selfonboarding/getSelfOnboardingActorQuery';
import getSelfOnboardingActorsQuery from './selfonboarding/getSelfOnboardingActorsQuery';
import getSelfOnboardingRepairersInfoQuery from './selfonboarding/getSelfOnboardingRepairersInfoQuery';
import upsertSelfOnboardingActorCommand from './selfonboarding/upsertSelfOnboardingActorCommand';
import upsertDefaultActorCommand from './upsertDefaultActorCommand';

export const ActorService = {
  getSalesChannelsQuery,
  getStoresQuery,
  upsertDefaultActorCommand,
  getActorSummary,
  getActorsBySellerIdQuery,
  getSelfOnboardingActorsQuery,
  deleteSelfOnboardingActorCommand,
  upsertSelfOnboardingActorCommand,
  getSelfOnboardingActorQuery,
  getSelfOnboardingRepairersInfoQuery,
  getStoreByExternalIdQuery,
  getSalesChannelsBySellerId,
  getStoresBySellerId,
};
